import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "./button.js";
const LOADING_TEXT = 'Loading...';
const DEFAULT_SIGN_IN_BUTTON_TEXT = 'Sign in with Fractal';
const DEFAULT_SIGN_OUT_BUTTON_TEXT = 'Sign out';
export const AuthButton = ({ loading = false, onClick, signedIn, variant, ...buttonProps }) => {
    const buttonText = signedIn
        ? DEFAULT_SIGN_OUT_BUTTON_TEXT
        : DEFAULT_SIGN_IN_BUTTON_TEXT;
    return (_jsx(Button, { ...buttonProps, onClick: onClick, theme: variant, children: loading ? LOADING_TEXT : buttonText }));
};
//# sourceMappingURL=auth-button.js.map